export default "/_next/static/9f2fb07d6434a080acd2f41d3cc013a1.png";